import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informe-calificaciones',
  templateUrl: './informe-calificaciones.component.html',
  styleUrls: ['./informe-calificaciones.component.scss']
})
export class InformeCalificacionesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
